import dateFormat from 'dateformat';

export const getBomCSVName = (projectId: string) => {
  const now = new Date();
  const date = dateFormat(now, 'yyyymmdd');

  return `${projectId.toLocaleUpperCase()} - ${date}`;
};

